var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":"","lg8":""}},[_c('material-card',{attrs:{"color":"orange","title":_vm.$t('page_404'),"text":_vm.$t('page_404_descr')}},[_c('v-img',{attrs:{"src":_vm.image,"height":"100%"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fec74e7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./VueSrc/Common/Page404.vue
// module id = 920
// module chunks = 0